import {useQuery} from "react-query";
import Alert from "react-s-alert";
import {HubAndSpokeService} from "../../../services/HubAndSpokeService";

export const useTemplateWorkflowsQuery = (templateName?: string) =>
  useQuery(
    ["GET_TEMPLATE_WORKFLOWS", templateName],
    async () => {
      const {data} = await HubAndSpokeService.getTemplateWorkflows(
        templateName,
      );
      return data;
    },
    {
      onError: () => {
        Alert.error("Failed to get template workflows.");
      },
      cacheTime: 0,
      enabled: !!templateName,
    },
  );
